import React from 'react';

export const SectionHeader = ({ titleText }: { titleText: string }) => {
  return (
    <h4 className="bg-neutral-off-white sky-h3 md:sky-h4 text-center h-24 p-4 flex justify-center items-center font-skyBold">
      {titleText}
    </h4>
  );
};
